import { environment } from '../../environments/environment';
import { IdentityProvider } from './index';

export const IdentityProviderRefreshTokenConfigMap: Record<IdentityProvider, { isEnabled: boolean }> = {
    [IdentityProvider.SwissLife]: environment?.refreshTokenConfig?.sl,
    [IdentityProvider.DfsIdentityServer]: environment?.refreshTokenConfig?.dfs
};
